import { frontendURL } from '../../../helper/URLHelper';

const SuperFuncionariosView = () => import('./SuperFuncionariosView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ia-super-funcionarios'),
    name: 'super_funcionarios_view',
    meta: { permissions: ['administrator'] },
    component: SuperFuncionariosView,
  },
];
